/**
 * ADMIN_GLOSSARY — plain-English labels + definitions for finance/ops jargon
 * shown across the Super Admin dashboard (2026-09-01 directive).
 *
 * Each entry: { basic: plain label, technical: original jargon, definition: hover copy }.
 * Consumed by <Jargon term="..."/> (components/admin/JargonTerm.jsx).
 */
export const ADMIN_GLOSSARY = {
    mrr: {
        basic: "Monthly income",
        technical: "MRR",
        definition: "Monthly Recurring Revenue — the money you collect from paying customers every month.",
    },
    arr: {
        basic: "Yearly income",
        technical: "ARR",
        definition: "Annual Recurring Revenue — monthly income × 12, your yearly income pace.",
    },
    arpu: {
        basic: "Avg. per customer",
        technical: "ARPU",
        definition: "Average Revenue Per User — total revenue divided by the number of paying customers.",
    },
    churn: {
        basic: "Customers lost",
        technical: "Churn",
        definition: "The share of paying customers who cancelled or downgraded in the period.",
    },
    mom_growth: {
        basic: "Growth vs last month",
        technical: "MoM Growth",
        definition: "Month-over-Month growth — how much a number changed compared to the previous month.",
    },
    breakeven: {
        basic: "Costs = income point",
        technical: "Break-even",
        definition: "The point where your income exactly covers your costs — no profit, no loss.",
    },
    runway: {
        basic: "Months of cash left",
        technical: "Runway",
        definition: "How many months your current cash on hand will last at today's spending rate.",
    },
    breakeven_runway: {
        basic: "Months of costs covered",
        technical: "Breakeven runway",
        definition: "How many months your already-locked-in revenue can cover your fixed running costs.",
    },
    run_rate: {
        basic: "Yearly pace",
        technical: "Run-rate",
        definition: "What this month's income would add up to over a full year, if it stayed the same.",
    },
    ytd: {
        basic: "This year so far",
        technical: "YTD",
        definition: "Year-to-date — totals added up since the start of the calendar year.",
    },
    sla: {
        basic: "Reliability target",
        technical: "SLA",
        definition: "Service Level Agreement — the reliability/speed target a data provider promises to meet.",
    },
    uptime: {
        basic: "Time it was working",
        technical: "Uptime",
        definition: "The percentage of time a service was up and responding correctly.",
    },
    latency: {
        basic: "Response speed",
        technical: "Latency",
        definition: "How long it takes a provider to respond to a request, in milliseconds — lower is faster.",
    },
    p95_latency: {
        basic: "Typical slow case",
        technical: "P95 latency",
        definition: "95% of requests were this fast or faster — a look at the slower end of normal, ignoring rare extreme outliers.",
    },
    kyc: {
        basic: "ID verification",
        technical: "KYC",
        definition: "Know Your Customer — the process of verifying who a customer is.",
    },
    pnl: {
        basic: "Profit/Loss",
        technical: "P&L",
        definition: "Profit and Loss — money made or lost on trades.",
    },
    dpa: {
        basic: "data-protection rules",
        technical: "DPA",
        definition: "Data Protection Agreement — a legal contract governing how personal data is handled.",
    },
    audit_chain: {
        basic: "Tamper-proof activity log",
        technical: "BeCo audit chain",
        definition: "A cryptographically linked record of events — editing an old entry visibly breaks every entry after it.",
    },
    quota: {
        basic: "usage limit",
        technical: "quota",
        definition: "The maximum number of requests a provider allows per day before blocking further calls.",
    },
    heartbeat: {
        basic: "health check",
        technical: "heartbeat",
        definition: "A recurring ping used to confirm a service is still alive and responding.",
    },
    kill_switch: {
        basic: "Emergency shut-off",
        technical: "Kill-switch",
        definition: "A one-time action that immediately turns off all safety-rule enforcement for a user.",
    },
};
